import { render, staticRenderFns } from "./ShiftsSlider.vue?vue&type=template&id=2a2004d0&lang=pug&"
import script from "./ShiftsSlider.vue?vue&type=script&lang=js&"
export * from "./ShiftsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports